import React, {Component} from "react";
import "./index.css";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import GradeManager, {GRADE_CONST} from "../../../../../components/Grade";
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import {toast} from "react-toastify";
import moment from "moment/moment";

class TransferByStudentManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {

            isShowText: true,
            gradeId: -1,
            classRoomId: -1,
            oldStudents: [],
            listClass: [],
            newClassRooms: [],
            listTransfer: [],


            contractCode: '',
            status: "UNFULFILLED",

            name: "",
            sort: '',
            pageNumber: 0,
            itemId: "",
            contractId: "",
            jobId: "",

            page: 0,
            pageSize: 10,
            totalItem: 0,
            listData: [],
            modalCloseJob: false,

            selectedJob: [],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Họ và tên",
                    // style: {minWidth: 140, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã học sinh",
                    // style: {minWidth: 100, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "birthday",
                    name: "Ngày sinh",
                    // style: {minWidth: 180, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "sex",
                    name: "Giới tính",
                    // style: {minWidth: 180, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "old-class",
                    name: "Lớp cũ",
                    // style: {minWidth: 180, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "to-class",
                    name: "Lớp chuyển đến",
                    // style: {minWidth: 165, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "receiveMoney",
                    name: "Kết chuyển",
                    // style: {minWidth: 120, textAlign: "center"},
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    onKetChuyen() {
        // let listItem = this.state.listTransfer.filter(item => item?item.isTransfer: false)
        let results = [];
        this.state.listTransfer.forEach((item, index) => {
            if (item.isTransfer){
                results.push({
                    "studentId": item.studentId,
                    "toClassId": item.toClassId,
                })
            }
        })
        if (results.length > 0){
            let payload = {
                yearId: parseInt(getSchoolYear()),
                items: results
            };
            ClassRoomController.ketChuyenHocSinh(payload, res => {
                if (res.success) {
                    toast.success("Kết chuyển thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    this.state.listTransfer = []
                    this.getListHocSinh()
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
                this.setState({
                    showLoading: false
                })
            })
        }else {
            toast.warning("Vui lòng chọn lớp kết chuyển", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }

    }
    getListHocSinh() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            classId: this.state.classRoomId,
        };
        ClassRoomController.listHocSinh(payload, res => {
            this.setState({
                oldStudents: res.data.oldStudents,
                newClassRooms: res.data.newClassRooms,
            });
        })
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 500,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClass: res.data.content
            });
        })
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    renderOldClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }

    onRenderNewClass() {
        return this.state.newClassRooms.map((item, index) => <option
            value={item.id}>{this.getClassName(item.name, item.grade)}</option>)
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListClass();
            }
        );
    };
    getHsDaKetChuyen(row) {
        let oldId = row.id
        let newId = row.classIdKetChuyen
        if (newId > 0) {
            return parseInt(row.sySo)- parseInt(row.students)
        } else {
            return this.state.listTransfer[oldId] ? this.state.listTransfer[oldId].studentsOk : 0
        }
    }
    getClassName(name, grade){
        return "["+GRADE_CONST[grade]+"] "+name
    }
    render() {
        let {
            header,
            oldStudents,
            totalItem,
            isShowText,
            gradeId
        } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 tab-content">
                        <div className="card col-12">
                            <div className="mb-2">
                                <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                    <div className="row kt-margin-b-20">
                                        <div className='col-md-6 p-0 pr-3 d-flex'>
                                            <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Khối[Năm học cũ]</label>
                                            <GradeManager
                                                isShowText={isShowText}
                                                gradeId={gradeId}
                                                onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                            />
                                        </div>
                                        <div className='col-md-6 p-0 pr-3 d-flex'>
                                        </div>
                                        <div className='col-md-6 p-0 pr-3 d-flex mt-2'>
                                            <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Lớp</label>
                                            <select
                                                className="form-control kt-input pd-4-input hei-input"
                                                value={this.state.classRoomId}
                                                onChange={(e) => {
                                                    if (e.target.value != ""){
                                                        this.state.classRoomId = parseInt(e.target.value);
                                                        this.setState({
                                                            classRoomId: e.target.value
                                                        }, ()=>{
                                                            this.getListHocSinh()
                                                        })
                                                    }
                                                }}
                                            >
                                                <option value="">Chọn lớp</option>
                                                {this.renderOldClass()}
                                            </select>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mt-2"
                                             style={{
                                                 alignItems: "center",
                                                 justifyContent: "right"
                                             }}>
                                            <button
                                                style={{height: 35, marginRight: 12, marginBottom: 8}}
                                                type="button"
                                                className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                onClick={() => {
                                                    this.onKetChuyen();
                                                }}
                                            >
                                                Kết chuyển
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div className="p-0 mb-3">
                                <div className="table-wrapper">
                                    <table className="table table-striped table-data table-bordered">
                                        <thead>
                                        <TableHeader
                                            header={header}
                                            clickSort={data => {
                                                let a = "";
                                                if (data.sortAsc == null) {
                                                    a = null;
                                                } else {
                                                    a = `${data.sortId}=${
                                                        data.sortAsc ? "created_at asc" : "created_at desc"
                                                    }`;
                                                }
                                            }}
                                        />
                                        </thead>
                                        {!this.state.oldStudents || this.state.oldStudents.length == 0 ? (
                                            <tbody>
                                            <tr>
                                                <td colSpan={9}>
                                                    <div className="text-center">Không có dữ liệu</div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        ) : (
                                            <tbody>
                                            {oldStudents.map((row, index) => (
                                                <tr style={{height: 50}}>
                                                    <td>
                                                        {" "}
                                                        {this.state.pageNumber * this.state.pageSize +
                                                            index +
                                                            1}
                                                    </td>
                                                    <td className="text-left">
                                                        {row.fullName}
                                                    </td>
                                                    <td className="text-left">
                                                        {row.code}
                                                    </td>
                                                    <td className="text-left">
                                                        {row.birthday ? moment(row.birthday).format("DD-MM-YYYY") : 'Chưa có dữ liệu'}
                                                    </td>
                                                    <td className="text-left">
                                                        {row.gender}
                                                    </td>
                                                    <td className="text-left">
                                                        {this.getClassName(row.currentClassRoomRes?.name, row.currentClassRoomRes?.grade)}
                                                    </td>
                                                    <td className="text-left">
                                                        <select
                                                            className="form-control kt-input pd-4-input hei-input"
                                                            value={this.state.listTransfer[row.id]?this.state.listTransfer[row.id]?.["toClassId"]: ""}
                                                            onChange={(e) => {
                                                                let newClass = parseInt(e.target.value)
                                                                let listItem = this.state.newClassRooms.filter(item => item.id== newClass)
                                                                if (!isNaN(newClass)){
                                                                    let data = this.state.listTransfer[row.id]
                                                                    if (data == undefined){
                                                                        this.state.listTransfer[row.id]= {
                                                                            "isTransfer": true,
                                                                            "studentId": row.id,
                                                                            "toClassId": newClass
                                                                        }
                                                                    }else {
                                                                        for(let transfer in this.state.listTransfer){
                                                                            if (transfer == row.id){
                                                                                this.state.listTransfer[transfer]["isTransfer"] = true
                                                                                this.state.listTransfer[transfer]["toClassId"] = newClass
                                                                                this.state.listTransfer[transfer]["studentId"] = row.id
                                                                                break
                                                                            }
                                                                        }
                                                                    }
                                                                }else {
                                                                    let data = this.state.listTransfer[row.id]
                                                                    if (data == undefined){
                                                                        this.state.listTransfer[row.id]= {
                                                                            "isTransfer": false,
                                                                            "toClassId": -1,
                                                                            "studentId": -1,
                                                                        }
                                                                    }else {
                                                                        for(let transfer in this.state.listTransfer){
                                                                            if (transfer == row.id){
                                                                                this.state.listTransfer[transfer]["toClassId"] = -1
                                                                                this.state.listTransfer[transfer]["studentId"] = -1
                                                                                this.state.listTransfer[transfer]["isTransfer"] = false
                                                                                break
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                this.setState(this.state.listTransfer);
                                                            }}
                                                        >
                                                            <option value="">Chọn lớp</option>
                                                            {this.onRenderNewClass()}
                                                        </select>
                                                    </td>
                                                    <td style={{textAlign: "center"}}>
                                                        <input
                                                            type="checkbox"
                                                            maxLength={255}
                                                            disabled={row.classIdKetChuyen>0}
                                                            checked={this.state.listTransfer[row.id]?this.state.listTransfer[row.id]?.["isTransfer"]: false}
                                                            className="shadow-none check-box-type"
                                                            onChange={(event) => {
                                                                let data = this.state.listTransfer[row.id]
                                                                if (data == undefined){
                                                                    this.state.listTransfer[row.id]= {
                                                                        "isTransfer": event.target.checked,
                                                                        "oldClassId": row.id
                                                                    }
                                                                }else {
                                                                    for(let transfer in this.state.listTransfer){
                                                                        if (transfer == row.id){
                                                                            this.state.listTransfer[transfer]["isTransfer"] = event.target.checked
                                                                            break
                                                                        }
                                                                    }
                                                                }
                                                                this.setState(this.state.listTransfer);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                                <div className="pagination-right">
                                    <Pagination
                                        activePage={this.state.pageNumber}
                                        itemsCountPerPage={this.state.pageSize}
                                        totalItemsCount={totalItem}
                                        changeHandler={page => this.handleChangePage(page)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default TransferByStudentManagement

